import data from "../../../../../platform_common_constants/meeting_constants.json"
import ChrPropTypes from "../../../../utils/ChrPropTypes";
export const MeetingConstants = data;

export const guidedConversationPropsList = {
  meetingSetGuidesConfig: ChrPropTypes.object,
  standaloneGuidesConfig: ChrPropTypes.object
}